import React, { FC } from "react";

import { AiBusinessSectionContextDetail } from "./AiBusinessSectionContextDetail";
import { AiBusinessSectionContextType } from "../types";

import { CatchTitleBorder } from "~/ui";
import { InfiniteScroll } from "~/ui";

type PropsType = {
  aiBusinessSectionContexts: AiBusinessSectionContextType[];
  isLoading: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  refetch: () => void;
  className?: string;
};

export const AiBusinessSectionContextDetails: FC<PropsType> = ({
  aiBusinessSectionContexts,
  isLoading,
  hasNextPage,
  fetchNextPage,
  refetch,
  className = "",
}: PropsType) => {
  return (
    <div className={className}>
      <CatchTitleBorder text="更新履歴" />
      <InfiniteScroll
        itemsLength={aiBusinessSectionContexts.length}
        nextFetchFunction={fetchNextPage}
        hasMore={hasNextPage}
        isLoading={isLoading}
        className={"mt-9"}
        scrollClassName={"space-y-6"}
        noContentMessage="AIカスタマイズがありません"
      >
        {aiBusinessSectionContexts.map((aiBusinessSectionContext) => (
          <AiBusinessSectionContextDetail
            key={aiBusinessSectionContext.id}
            aiBusinessSectionContext={aiBusinessSectionContext}
            refetch={refetch}
          />
        ))}
      </InfiniteScroll>
    </div>
  );
};
